import React, { PropsWithChildren, useContext } from "react";
import { RenderLeafProps } from "slate-react";
import { PowerEditorBaseProps } from "./slate/PowerEditorConfig";
import { BlockHint, Suggestion } from "./PowerEditorSettingsSuggestions";
import { PowerEditorDefaultSuggestions } from "./PowerEditorDefaultSuggestions";

export type BlockSettingsByType = Record<string, string[]>


export interface PowerEditorSettings {
    EditorComponent?: React.ComponentType<PowerEditorBaseProps>;
    CustomLeaf?: (props: RenderLeafProps) => JSX.Element;
    noBlockSettings?: boolean;
    suggestedBlockSettings?: string[];
    suggestedBlockSettingsByType: BlockSettingsByType;
    suggestedBlockSettingValues?: Record<string, BlockSettingsByType>;
    settingsSuggestions?: Suggestion[];
    blockHints?: BlockHint[];
}

const DefaultSettings: PowerEditorSettings = {
  suggestedBlockSettingsByType: {},
  settingsSuggestions: PowerEditorDefaultSuggestions,
}

export const PowerEditorSettingsContext = React.createContext<PowerEditorSettings>(DefaultSettings);

export const PowerEditorSettingsProvider = (props: PropsWithChildren<Partial<PowerEditorSettings>>) => {
    const { children, ...settings } = props;

    return <PowerEditorSettingsContext.Provider value={{ ...DefaultSettings, ...settings }}>
        {children}
    </PowerEditorSettingsContext.Provider>
};

export const createWrappedPowerEditor = (settings: Omit<Partial<PowerEditorSettings>, "EditorComponent"> & { EditorComponent: NonNullable<PowerEditorSettings["EditorComponent"]>}) => {
  const Editor = settings.EditorComponent;
  return (props: PowerEditorBaseProps) => (
      <PowerEditorSettingsProvider {...settings}>
          <Editor {...props} />
      </PowerEditorSettingsProvider>
  );
}

export const usePowerEditorSettings = () => useContext(PowerEditorSettingsContext);

